import { render, staticRenderFns } from "./EditFamille.vue?vue&type=template&id=546088f0&"
import script from "./EditFamille.vue?vue&type=script&lang=ts&"
export * from "./EditFamille.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VTextField})
